import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { Link } from 'react-router-dom';
import { vEmail } from '@tokenyico/design-system';
import { DsForm, DsInputString, DsButton } from '@tokenyico/design-system/dist/reactJS';

import { formActions } from 'app/state/actions';
import { AuthenticationService } from 'services';

const mapToProps = (state) => state;

const ForgotPasswordAuthView = ({ history, setError }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function submitHandler() {
    try {
      setIsSubmitting(true);
      await AuthenticationService.forgotPassword(email);
      setIsSubmitting(false);
      history.push('/auth/reset-password', { email });
    } catch (error) {
      setIsSubmitting(false);
      if (error.code === 'UserNotFoundException') {
        setError(t('validation.emailNotFound'));
      } else if (
        error.code === 'InvalidParameterException' &&
        error.message.includes('no registered/verified email')
      ) {
        setError(t('validation.emailUnverified'));
        history.push('/auth/confirm-signup');
      } else if (error.code === 'LimitExceededException') {
        setError(t('validation.tooManyResets'));
      } else {
        setError(error);
      }
    }
  }

  return (
    <div className="card auth">
      <h1 className="auth__title">{t('shared.forgotPassword')}</h1>
      <DsForm onSubmit={submitHandler} id="forgot-password">
        <DsInputString
          label={t('shared.email')}
          isFloatLabel={false}
          name="email"
          type="email"
          value={email}
          onDsInput={({ detail }) =>
            setEmail(typeof detail === 'string' ? detail.toLocaleLowerCase() : detail)
          }
          validate={vEmail}
          className="_m:y(2)"
        />

        <div className="auth__button-primary">
          <DsButton
            fullWidth
            version="primary"
            label={t('shared.sendCode')}
            type="submit"
            isLoading={isSubmitting}
          />
        </div>
        <div className="auth__footer">
          <Link to="/">
            <DsButton label={t('shared.backToSignIn')} mode="text" id="sign-in" />
          </Link>
        </div>
      </DsForm>
    </div>
  );
};

export default connect(mapToProps, formActions)(ForgotPasswordAuthView);
